// Home.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCity } from "../context/CityContext";

import "../styles/Home.css";
import "../styles/NewHome.css";

import Conferencecategory1 from "../ui-assets/home/category_conf.png";
import Exhibitioncategory2 from "../ui-assets/home/category_expo.png";
import Concertcategory3 from "../ui-assets/home/category_marathon.png";
import Meetupcategory4 from "../ui-assets/home/category_meetup.png";

import HomeEventBanner from "../components/HeroEventBannerCarosuel.js";
import HomeupcomingEvents from "../components/UpcomingEvent.js";
import HometrendingEvents from "../components/TrendingEvent.js";
import MainFooter from "../components/MainFooter.js";
import WhyChooseEventfork from "../components/ Whychooseeventfork.js";
import AnimatedWorkflowBackground from "../components/AnimatedWorkflowBackground.js";

import {
  FaMicrophone,
  FaUsers,
  FaStore,
  FaCalendarAlt,
  FaShieldAlt,
   FaMusic,
   FaGraduationCap,
   FaRunning,
  FaBolt,
} from "react-icons/fa";


import HomeHeroCarousel from "../components/HomeHeroCarousel.js";


/* ---------------- Custom Hook for Scroll Reveal ---------------- */



const useScrollReveal = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");

            // Clean up will-change after animation
            entry.target.addEventListener('transitionend', () => {
              entry.target.style.willChange = 'auto';
            }, { once: true });
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    // Select all elements with reveal classes
    const elements = document.querySelectorAll(
      '.reveal, .reveal-stagger, .reveal-glide, .reveal-pop, .reveal-glow, .reveal-perspective, .reveal-parallax, .reveal-magnetic'
    );

    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
      observer.disconnect();
    };
  }, []);
};

/* ---------------- Category Icons ---------------- */

const PeopleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8.5" cy="8" r="3" fill="currentColor" />
    <circle cx="16" cy="9" r="2.4" fill="currentColor" opacity="0.85" />
    <path
      d="M3 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M14.5 15.2c2.6.2 4.5 2 4.5 3.8"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const StorefrontIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 9.5 5 4h14l1 5.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M4 9.5c0 1.4 1.1 2.5 2.5 2.5S9 10.9 9 9.5c0 1.4 1.1 2.5 2.5 2.5S14 10.9 14 9.5c0 1.4 1.1 2.5 2.5 2.5S19 10.9 19 9.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.5 12v8h13v-8" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M10 20v-4.5h4V20" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
  </svg>
);

const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="5.5" width="16" height="14" rx="2.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M4 9.5h16" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 3.5v3M16 3.5v3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="8.5" cy="13.5" r="1.1" fill="currentColor" />
    <circle cx="12" cy="13.5" r="1.1" fill="currentColor" />
    <circle cx="15.5" cy="13.5" r="1.1" fill="currentColor" />
  </svg>
);

/* ---------------- Arrow Icon ---------------- */

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M5 12H19M19 12L13 6M19 12L13 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ---------------- Category Data ---------------- */

const categories = [
  {
    key: "Conferance",
    accent: "violet",
    image: Conferencecategory1,
    title: "Conference",
    description: "Gain knowledge, insights and learn from industry experts.",
    linkLabel: "Explore Conference",
    icon: PeopleIcon,
    path: "/category/Conferance",
  },
  {
    key: "Expo/Exibition",
    accent: "amber",
    image: Exhibitioncategory2,
    title: "Expo / Exhibition",
    description: "Discover new products, innovations and business opportunities.",
    linkLabel: "Explore Expo",
    icon: StorefrontIcon,
    path: "/category/Expo%2FExibition",
  },
  {
    key: "Event",
    accent: "magenta",
    image: Concertcategory3,
    title: "Event",
    description: "Experience live shows, concerts and exciting happenings.",
    linkLabel: "Explore Events",
    icon: CalendarIcon,
    path: "/category/Event",
  },
  {
    key: "Meetup",
    accent: "teal",
    image: Meetupcategory4,
    title: "Meetup",
    description: "Connect with like-minded people and grow your network.",
    linkLabel: "Explore Meetups",
    icon: PeopleIcon,
    path: "/category/Meetup",
  },
];

const Home = () => {
  const navigate = useNavigate();
  const { selectedCity } = useCity();

  // Add isMobile state
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Initialize scroll reveal
  useScrollReveal();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cityLabel = selectedCity || "All Cities";

  return (
    <div className="home landing-page">
      {/* Banner Section with Animated Workflow Background */}
      <section className="banner hero-section">


        {/*  <AnimatedWorkflowBackground /> */}

        <div className="container hero-container-wrapper">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="banner-content">
                <span className="hero-badge reveal reveal-left delay-1">
                  <span className="dot"></span> No fees. No limits. Any event, any size.
                </span>

                <h1 className="reveal reveal-glide delay-2">
                  EXPLORE EVENTS <span className="highlight">MEET PEOPLE</span>  <span className="single-line">CREATE MEMORIES</span>
                </h1>

                <p className="reveal reveal-left delay-3">
                  A platform for every passion. Explore events that inspire, educate, and entertain. Network with like-minded individuals and scale your conferences effortlessly—all free to use.
                </p>

                <div className="hero-btn-group1">
                  <a href="/all-event" className="hero-btn-primary reveal reveal-bottom delay-3">
                    Browse Events
                  </a>

                  <div className="hero-create-link reveal reveal-bottom delay-4">
                    <span>Hosting an event?</span>
                    <a href="/create-event">
                      Create Now <span>→</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>


            <div className="col-md-6 home-hero-right">

              <HomeHeroCarousel />
              {/* <div className="ef-hero-stats reveal reveal-magnetic delay-2">
                <div className="ef-stat-item">
                  <div className="ef-stat-icon ef-purple">
                    <FaShieldAlt />
                  </div>
                  <div className="ef-stat-content">
                    <h5>100% Free</h5>
                    <span>Forever</span>
                  </div>
                </div>

                <div className="ef-stat-divider"></div>

                <div className="ef-stat-item">
                  <div className="ef-stat-icon ef-orange">
                    <FaBolt />
                  </div>
                  <div className="ef-stat-content">
                    <h5>Instant Setup</h5>
                    <span>No hassle</span>
                  </div>
                </div>

                <div className="ef-stat-divider"></div>

                <div className="ef-stat-item">
                  <div className="ef-stat-icon ef-green">
                    <FaUsers />
                  </div>
                  <div className="ef-stat-content">
                    <h5>Built for</h5>
                    <span>Everyone</span>
                  </div>
                </div>
              </div> */}
            </div>

{/* Event Category Icons */}
<div className="ef-category-strip">
  {[
    { label: "Conferences", icon: FaMicrophone },
    { label: "Meetups", icon: FaUsers },
    { label: "Music", icon: FaMusic },
    { label: "Exhibitions", icon: FaStore },
    { label: "Workshops", icon: FaGraduationCap },
    { label: "Marathons", icon: FaRunning },
  ].map(({ label, icon: Icon }, index, categories) => (
    <div className="ef-category-item" key={label}>
      <Icon className="ef-category-icon" />
      <span>{label}</span>

      {index !== categories.length - 1 && (
        <span className="ef-category-divider" />
      )}
    </div>
  ))}
</div>





          </div>
        </div>
      </section>


      {/* Home page event banner slider */}
      <section className="homeEvent-banner reveal reveal-glow">
        <div className="container">
          <HomeEventBanner />
        </div>
      </section>

      {/* Upcoming events cards data section - FIXED: Proper wrapper with flex layout */}
      <section className="container upcoming-event-wrapper reveal reveal-glow">
        <div className="upcoming-header-wrapper">
          <h2>
            Upcoming Events in <span>{cityLabel}</span>
          </h2>
          <h6
            className="reveal reveal-right delay-1"
            onClick={() => navigate("/all-event")}
            style={{ cursor: 'pointer' }}
          >
            See all Events
          </h6>
        </div>
        <HomeupcomingEvents />
      </section>


      {/* Browse by categories section */}
      <section className="categories-section">
        <div className="categories-container">
          <div className="categories-header">

            <h2 className="categories-heading reveal reveal-glow delay-1">
              Browse Events by <span className="heading-highlight">Categories</span>
            </h2>

            <p className="categories-subtext reveal reveal-glow delay-2">
              Find events that match your interests and be part of something amazing.
            </p>
          </div>

          <div className="categories-grid">
            {categories.map((category, index) => {
              const Icon = category.icon;
              const delayClass = `delay-${index + 1}`;
              return (
                <article
                  key={category.key}
                  className={`category-item reveal reveal-glow ${delayClass}`}
                  data-accent={category.accent}
                  onClick={() => navigate(category.path)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") navigate(category.path);
                  }}
                >
                  <div className="category-visual">
                    <svg className="rotating-ring" viewBox="0 0 240 240">
                      <circle
                        cx="120"
                        cy="120"
                        r="112"
                        className="ring-circle"
                      />
                    </svg>
                    <div className="visual-blob">
                      <img src={category.image} alt={category.title} loading="lazy" />
                    </div>
                  </div>

                  <h3 className="category-name">
                    {category.title}
                    <span className="name-underline" />
                  </h3>

                  <p className="category-desc">{category.description}</p>

                  <button
                    type="button"
                    className="category-link"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(category.path);
                    }}
                  >
                    <span>{category.linkLabel}</span>
                    <span className="link-arrow">
                      <ArrowIcon />
                    </span>
                  </button>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* Trending events right now section */}
     
<section className="trending-event-section reveal reveal-glow">
  <div className="container">
    <h2 className="reveal reveal-glow delay-1">
      Trending Events{" "}
      <span className="gradient-text">Right Now</span>
      {selectedCity ? ` in ${selectedCity}` : ""}
    </h2>

    <HometrendingEvents />
  </div>
</section>


      <div className="reveal reveal-glow">
        <WhyChooseEventfork />
      </div>

      <footer className="landing-footer reveal reveal-glow">
        <MainFooter />
      </footer>
    </div>
  );
};

export default Home;